import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { RootState } from 'reducers/rootReducer'
import { getOpeningHours } from 'actions/actionMenu.action'
import IOpeningHours from 'models/IOpeningHours'

export interface OpeningHoursBoxProps {
  title: string
  setShowOpeningHoursBox: React.Dispatch<React.SetStateAction<boolean>>
}

export const useOpeningHoursBox = (props: OpeningHoursBoxProps) => {
  const { restaurantName } = useParams<{ restaurantName: string }>()

  const dispatch = useAppDispatch()

  const isLoading: boolean = useSelector(
    (state: RootState) => state.actionMenu.isLoading
  )
  const isGetOpeningHoursSuccess: boolean | null = useSelector(
    (state: RootState) => state.actionMenu.isGetOpeningHoursSuccess
  )
  const getOpeningHoursResponseMessage: string | null = useSelector(
    (state: RootState) => state.actionMenu.getOpeningHoursResponseMessage
  )
  const openingHours: IOpeningHours[] | null = useSelector(
    (state: RootState) => state.actionMenu.openingHours
  )
  const boxBgColor: string | undefined = useSelector(
    (state: RootState) =>
      state.restaurantInfo.restaurantInfo?.colors.popupBackground
  )
  const boxTitleColor: string | undefined = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo?.colors.popupTitle
  )
  const hoursBg: string | undefined = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo?.colors.popupButtonBackground
  )

  useEffect(() => {
    try {
      if (!openingHours) dispatch(getOpeningHours(restaurantName || ''))
    } catch (error) {
      console.error(error)
    }
  }, [])

  return {
    ...props,
    openingHours,
    boxBgColor,
    boxTitleColor,
    hoursBg,
    getOpeningHoursResponseMessage,
    isLoading,
    isGetOpeningHoursSuccess,
  }
}
